import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["active", "hovered", "pointySide", "$isBetaButton", "$minimized"],
  _excluded2 = ["children", "minimized", "pointySide", "style"];
import { getFabAfterStyles, getFabBeforeStyles, getFabBetaButtonStyles, getFabMinimizedStyles, getFabStyles } from './FloatingActionButton.helpers';
import { ActiveProvider } from '../../../transitional/utils/useActive';
import { Clickable } from '../../../transitional/components/Clickable/Clickable';
import { HoverProvider } from '../../../transitional/utils/useHovered';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { useFloatingActionButtonContext } from './FloatingActionButtonProvider';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const Fab = styled(_ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Clickable, Object.assign({}, rest));
}).withConfig({
  displayName: "FloatingActionButton__Fab",
  componentId: "sc-1hzhyx8-0"
})(["", ";", ";", ";&::after{", "}&::before{", "}"], props => getFabStyles(props), props => props.$isBetaButton && getFabBetaButtonStyles(props), props => props.$minimized && getFabMinimizedStyles(), props => getFabAfterStyles(props), props => getFabBeforeStyles(props));
export const FloatingActionButton = _ref2 => {
  let {
      children,
      minimized = false,
      pointySide = 'bottom-left',
      style
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  const {
    isBetaButton
  } = useFloatingActionButtonContext();
  const {
    domProps,
    tokenProps,
    callbackProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(HoverProvider, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(ActiveProvider, {
      children: activeProviderProps => /*#__PURE__*/_jsx(Fab, Object.assign({}, hoverProviderProps, activeProviderProps, {
        pointySide: pointySide,
        $cssStyles: cssStyles,
        $isBetaButton: isBetaButton,
        $minimized: minimized,
        style: style
      }, domProps, callbackProps, {
        children: children
      }))
    })
  });
};
FloatingActionButton.displayName = 'FloatingActionButton';